import * as R from 'ramda';

export default function AssignTopRiskTypesDialogController(
  $q,
  $rootScope,
  $scope,

  ssDialogService,
  alerts,
  loaderService,
  assetDataService,
  riskDataService,
  riskSharedModelService,
  editRiskTypeDialog,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleAssignTopRiskTypesSubmit = _handleAssignTopRiskTypesSubmit;
  vm.handleAddRiskTypeDialogClick = _handleAddRiskTypeDialogClick;

  _activate();

  // //////// METHODS //////////
  function _activate() {
    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshRiskTypes', () => {
      _refreshRiskTypes();
    });
    // $scope.$on('pra_risk-type-created', (event, payload) => {
    //   console.log(payload);
    // });
    // $scope.$on('pra_risk-type-updated', (event, payload) => {
    //   console.log(payload);
    // });
    // $scope.$on('pra_risk-type-deleted', (event, payload) => {
    //   console.log(payload);
    // });
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.assignTopRiskTypesDialog);
  }

  function _handleAssignTopRiskTypesSubmit() {
    if ($scope.assignTopRiskTypesForm.$valid) {
      loaderService.showViewLoader = true;
      const riskTypes = [];
      R.forEach(
        (item) => {
          if (item.isAssigned === true) {
            riskTypes.push(item);
          }
        },
        vm.riskTypes
      );
      // if (riskTypeIds.length === 0) {
      //   riskTypeIds.push(-1);
      // }
      assetDataService.saveAssetRiskTypes(vm.assetType.customerAssetTypeId, riskTypes).then((response) => {
        if (response.status === 200) {
          alerts.success('The Top Risks have been assigned to the Asset Type successfully.');
          vm.saved = true;
          $rootScope.$broadcast('refreshTopRiskTypes', { assetType: response.data });
          ssDialogService.hide(ssDialogService.dialogs.assetAdmin.assignTopRiskTypesDialog);
        } else {
          alerts.error('An error occurred while assigning the Top Risks to the Asset Type.');
        }
        loaderService.showViewLoader = false;
      });
    }
  }

  function _handleAddRiskTypeDialogClick($event) {
    const riskType = { customerRiskTypeId: 0 };
    const promises = [
      riskDataService.getRiskTypeDefaults(),
      getInitRiskAdmin(),
    ];
    return $q.all(promises).then((response) => {
      loaderService.showViewLoader = false;
      riskType.riskOnset = response[0].data.riskOnset;
      riskType.riskForewarning = response[0].data.riskForewarning;
      riskType.riskDuration = response[0].data.riskDuration;
      riskType.riskDataConfidentiality = response[0].data.riskDataConfidentiality;
      riskType.riskDataIntegrity = response[0].data.riskDataIntegrity;
      riskType.riskDataAvailability = response[0].data.riskDataAvailability;
      riskType.riskDirection = response[0].data.riskDirection;
      riskType.riskTrending = response[0].data.riskTrending;
      riskType.riskAssessmentFrequency = response[0].data.riskAssessmentFrequency;
      riskType.riskProbability = response[0].data.riskProbability;
      riskType.riskClassification = response[0].data.riskClassification;
      ssDialogService.dialogs.riskAdmin.editRiskTypeDialog = ssDialogService.alert(
        editRiskTypeDialog.getOptions($event, {
          risk: riskType,
          riskOnsets: riskSharedModelService.RiskOnsets,
          riskForewarnings: riskSharedModelService.RiskForewarnings,
          riskDurations: riskSharedModelService.RiskDurations,
          riskDataConfidentialities: riskSharedModelService.RiskDataConfidentialities,
          riskDataIntegrities: riskSharedModelService.RiskDataIntegrities,
          riskDataAvailabilities: riskSharedModelService.RiskDataAvailabilities,
          riskDirections: riskSharedModelService.RiskDirections,
          riskTrendings: riskSharedModelService.RiskTrendings,
          riskAssessmentFrequencies: riskSharedModelService.RiskAssessmentFrequencies,
          riskProbabilities: riskSharedModelService.RiskProbabilities,
          riskClassifications: riskSharedModelService.RiskClassifications,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.riskAdmin.editRiskTypeDialog);
    });
  }

  function getInitRiskAdmin() {
    if (riskSharedModelService.RiskOnsets && riskSharedModelService.RiskOnsets.length > 0) {
      return Promise.resolve();
    }
    return riskDataService.initRiskAdmin().then((getRiskInitResponse) => {
      if (!getRiskInitResponse.data) {
        alerts.error('Error occurred get risk init data.');
      } else {
        if (getRiskInitResponse.data.RiskOnsets) {
          riskSharedModelService.RiskOnsets = getRiskInitResponse.data.RiskOnsets.result;
        }

        if (getRiskInitResponse.data.RiskForewarnings) {
          riskSharedModelService.RiskForewarnings = getRiskInitResponse.data.RiskForewarnings.result;
        }

        if (getRiskInitResponse.data.RiskDurations) {
          riskSharedModelService.RiskDurations = getRiskInitResponse.data.RiskDurations.result;
        }

        if (getRiskInitResponse.data.RiskDataConfidentialities) {
          riskSharedModelService.RiskDataConfidentialities = getRiskInitResponse.data.RiskDataConfidentialities.result;
        }


        if (getRiskInitResponse.data.RiskDataIntegrities) {
          riskSharedModelService.RiskDataIntegrities = getRiskInitResponse.data.RiskDataIntegrities.result;
        }

        if (getRiskInitResponse.data.RiskDataAvailabilities) {
          riskSharedModelService.RiskDataAvailabilities = getRiskInitResponse.data.RiskDataAvailabilities.result;
        }

        if (getRiskInitResponse.data.RiskDirections) {
          riskSharedModelService.RiskDirections = getRiskInitResponse.data.RiskDirections.result;
        }

        if (getRiskInitResponse.data.RiskTrendings) {
          riskSharedModelService.RiskTrendings = getRiskInitResponse.data.RiskTrendings.result;
        }

        if (getRiskInitResponse.data.RiskAssessmentFrequencies) {
          riskSharedModelService.RiskAssessmentFrequencies = getRiskInitResponse.data.RiskAssessmentFrequencies.result;
        }

        if (getRiskInitResponse.data.RiskProbabilities) {
          riskSharedModelService.RiskProbabilities = getRiskInitResponse.data.RiskProbabilities.result;
        }
      }
    });
  }


  function _refreshRiskTypes() {
    $q.all([
      assetDataService.getAssetType(vm.assetType.customerAssetTypeId),
      riskDataService.getRiskTypes()
    ]).then((results) => {
      vm.assetType = { ...vm.assetType, ...results[0].data };
      vm.riskTypes = results[1].data.result;
      _getRiskTypeList();
    });
  }

  function _getRiskTypeList() {
    vm.riskTypes = R.map((riskType) => {
      riskType.isAssigned = false;
      let isAssigned = false;
      if (vm.assetType.customerRiskTypes && vm.assetType.customerRiskTypes.length > 0) {
        isAssigned = R.find(
          R.propEq('customerRiskTypeId', riskType.customerRiskTypeId),
          vm.assetType.customerRiskTypes
        );
      }
      if (isAssigned) {
        riskType.isAssigned = true;
      }
      return riskType;
    }, vm.riskTypes);
  }
}

AssignTopRiskTypesDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'ssDialogService',
  'alerts',
  'loaderService',
  'assetDataService',
  'riskDataService',
  'riskSharedModelService',
  'editRiskTypeDialog',
];
